import { Dropdown } from "primereact/dropdown";
import React, { useRef, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { VscSaveAs } from "react-icons/vsc";

const DynamicForm = ({
  master,
  index,
  inputType,
  selectedAttributes,
  onEditLabel,
  AttributeOnChange,
  handleChange
}) => {
  const [edit, setEdit] = useState("false");

  const labelRef = useRef(null);

  const handleInputChange = (i, name, value) => {
    //  console.log("index",i);
    //  console.log("name",name);
    //  console.log("value",value);
    AttributeOnChange && AttributeOnChange(i, name, value);
  };
  const handleLabelChange = () => {
    const labelText = labelRef.current.innerText;
    onEditLabel && onEditLabel(labelText);
  };

  const renderAttribute = (
    attributes,
    selected_attribute,
    handleInputChange
  ) => {
    // console.log("attributes", attributes);
    // console.log("attributes::KEy", Object.keys(attributes));

    const Attribs = Object.keys(attributes).map((attributeTypes, i) => {
      if (attributeTypes === "date") {
        return attributes[attributeTypes].map((attr, i) => {
          return (
            <div className="d-flex">
              <label
                key={`"date"${i}`}
                className="form-label"
                htmlFor={`${attr}-${i}`}
              >
                {attr}
              </label>
              <input
                className="form-input"
                name={attr}
                type="date"
                id={`${attr}-${i}`}
                checked={
                  selected_attribute && selected_attribute[attr] === true
                }
                onChange={(e) =>
                  handleInputChange(index, attr, e.target.checked)
                }
              />
            </div>
          );
        });
      }
      if (attributeTypes === "boolean") {
        return attributes[attributeTypes].map((attr, i) => {
          return (
            <div className="d-flex">
              <label
                key={`boolean${i}`}
                className="form-label"
                htmlFor={`${attr}-${i}`}
              >
                {attr}
                <input
                  className="form-input"
                  name={attr}
                  type="checkbox"
                  id={`${attr}-${i}`}
                  checked={
                    selected_attribute && selected_attribute[attr] === true
                  }
                  onChange={(e) =>
                    handleInputChange(index, attr, e.target.checked)
                  }
                />
              </label>
            </div>
          );
        });
      }
      if (attributeTypes === "number") {
        return attributes[attributeTypes].map((attr, i) => {
          return (
            <label
              key={`number${i}`}
              className="form-label"
              htmlFor={`${attr}-${i}`}
            >
              {attr}
              <input
                className="form-input"
                name={attr}
                type="number"
                id={`${attr}-${i}`}
                onChange={(e) => handleInputChange(index, attr, e.target.value)}
              />
            </label>
          );
        });
      }
      if (attributeTypes === "text") {
        return attributes[attributeTypes].map((attr, i) => {
          return (
            <label
              key={`text${i}`}
              className="form-label"
              htmlFor={`${attr}-${i}`}
            >
              {attr}
              <input
                className="form-input"
                name={attr}
                type="text"
                id={`${attr}-${i}`}
                checked={attr}
                onChange={(e) => handleInputChange(index, attr, e.target.value)}
              />
            </label>
          );
        });
      }
    });

    return Attribs;
  };
 
  const renderInput = (inputType,selectedAttributes, handleInputChange) => {
    console.log(inputType);
    const commonAttributes = {
      type: inputType.type,
      ...selectedAttributes
    };

    switch (inputType.type) {
      case "boolean":
        return (
          <input 
          onChange={(e)=>handleInputChange(e,index, `setting-${index}`,e.target.value)} 
          // checked={}
          name={`setting-${index}`} 
          id={`setting-${index}`} 
          className="form-input" {...commonAttributes} />    

        );
      case "textarea":
        return (
          <div>
            <textarea
            name={`setting-${index}`}
            onChange={(e)=>handleInputChange(e,index, `setting-${index}`,e.target.value)}
            id={`setting-${index}`}
              className="form-input"
              {...commonAttributes}
              rows="4"
              cols="50"
            ></textarea>
          </div>
        );
      case "range":
        return (
          <div>
            <label className="form-label" htmlFor={`setting-min-${index}`}>
              Min
              <input   onChange={(e)=>handleInputChange(e,index, `setting-min-${index}`,e.target.value)}  name={`setting-min-${index}`}   id={`setting-min-${index}`} className="form-input" type="text" />
            </label>
            <label className="form-label" htmlFor={`setting-max-${index}`}>
              Max
              <input   onChange={(e)=>handleInputChange(e,index, `setting-max-${index}`,e.target.value)} name={`setting-max-${index}`}   id={`setting-max-${index}`} className="form-input" type="text" />
            </label>
            
          </div>
        );
      case "dropdown":
        return (
          <>
            <Dropdown
              options={selectedAttributes?.options?typeof selectedAttributes?.options==="string"?selectedAttributes?.options.split(','):selectedAttributes?.options:[]}
               onChange={(e)=>handleInputChange(e,index, `setting-${index}`,e.target.value)}
              name={`setting-${index}`}
              style={{ width: "100%", borderRadius: "5px", height: "1.9rem" }}
              className="w-full"
            />            
          </>
        );
      default:
        return (
          <>
            <input onChange={(e)=>handleInputChange(e,index, `setting-${index}`,e.target.value)} name={`setting-${index}`} className="form-input" {...commonAttributes} />          
          </>
        );
    }
  };

  return (
    <form>
      <div key={index + inputType.label} className="form-group">
        {/* <div className="d-flex align-items-center">
          <label
            ref={labelRef}
            className="form-label"
            htmlFor={index + inputType.label}
            contentEditable={edit}
            suppressContentEditableWarning={true}
            autoFocus ={Boolean(edit)}
            onInput={handleLabelChange}
            style={{
              border: "1px solid var(--bg-tbl-header)",
              paddingInline: "1rem",
              borderRadius: "5px",
            }}
          >
            {inputType.label}
          </label>

          {edit === "false" ? (
            <CiEdit
              style={{ fontSize: "2rem", cursor: "pointer" }}
              onClick={() => {
                setEdit((p) => (p === "false" ? "true" : "false"));
                edit === "true" && labelRef.current.focus();
              }}
            />
          ) : (
            <VscSaveAs
              style={{ fontSize: "2rem", cursor: "pointer" }}
              onClick={() => {
                setEdit((p) => (p === "false" ? "true" : "false"));
                edit === "true" && labelRef.current.focus();
              }}
            />
          )}
        </div> */}
        
        <div className="col-3">
              {master && renderAttribute(
                inputType.attributes,
                inputType.selected_attribute,
                handleInputChange
              )}
            </div>
        {!master && renderInput(inputType,selectedAttributes, handleChange)}
      </div>
    </form>
  );
};

export default DynamicForm;
